import pacsmaster from "./ms421";
import exposurelimitagri from "./exposurelimitagri";
import membermasteragri from "./membermasteragri";
import scaleoffinanceagri from "./scaleoffinanceagri";
import loanrequestagri from "./loanrequestagri";
import approvalsagri from "./approvalsagri";
import disburseagri from "./disburseagri";
import recoveryagri from "./recoveryagri";
import tr045 from "./tr045";
import ms451 from "./ms451";

import ms421 from "./ms421";
// import ms442 from "./ms442";
import ms443 from "./ms443";

import hr015 from "./hr015";
import ms444 from "./ms444";
import ms445 from "./ms445";




import ms446 from "./ms446";

export default {

ms446,



ms445,
ms444,
hr015,



  pacsmaster,
  exposurelimitagri,
  membermasteragri,
  scaleoffinanceagri,
  loanrequestagri,
  approvalsagri,
  disburseagri,
  recoveryagri,
  tr045,
  ms451,
  ms421,
  // ms442,
  ms443
};
